var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable prettier/prettier */
import React, { useMemo, useState } from 'react';
import { Checkbox, Radio } from 'antd';
// import styles from '../styles';
// import Avatar, { DefaultUserAvatar } from '../Avatar';
import Avatar from '../Avatar';
import classNames from 'classnames';
import { Tags } from '../Tags';
import { getHeadImgThumbUrl } from '../utils';
import { sortBy } from 'lodash';
import UserSelectionContext from '../UserSelection/context';
import closeIcon from '../images/log_del.png';
export var DefaultAvatarSize = 36;
// eslint-disable-next-line complexity
export default function ListItem(_a) {
    var data = _a.data, extra = _a.extra, rightExtra = _a.rightExtra, hoverStyle = _a.hoverStyle, className = _a.className, checkedEnable = _a.checked, checkable = _a.checkable, single = _a.single, defualtImg = _a.defualtImg, disabled = _a.disabled, active = _a.active, style = _a.style, onClick = _a.onClick, onItemDelete = _a.onItemDelete, onCheckChange = _a.onCheckChange, onChangeItem = _a.onChangeItem, onChangeDataAll = _a.onChangeDataAll, tag = _a.tag, selector = _a.selector, itemShowRemark = _a.itemShowRemark, other = __rest(_a, ["data", "extra", "rightExtra", "hoverStyle", "className", "checked", "checkable", "single", "defualtImg", "disabled", "active", "style", "onClick", "onItemDelete", "onCheckChange", "onChangeItem", "onChangeDataAll", "tag", "selector", "itemShowRemark"]);
    var _b = React.useContext(UserSelectionContext), tabs = _b.tabs, frozenIds = _b.frozenIds, isShowRemark = _b.isShowRemark;
    var _c = useState(false), hover = _c[0], setHover = _c[1];
    var _d = data || {}, name = _d.name, avatar = _d.avatar, desc = _d.desc, checked = _d.checked, defaultAvatar = _d.defaultAvatar, isLeader = _d.isLeader, administratorType = _d.administratorType, labelInfoList = _d.labelInfoList, remark = _d.remark, isGroup = _d.isGroup;
    var isCheckEnable = checkable || checkedEnable;
    var hStyle = hover ? hoverStyle || {} : {};
    var origin = data.origin || {};
    var freeze = (frozenIds || []).findIndex(function (a) { return a === data.id; }) >= 0;
    var sortTagList = (labelInfoList &&
        labelInfoList.length &&
        sortBy(labelInfoList, function (item) {
            return item.index;
        })) ||
        [];
    var reamrkIsNull = useMemo(function () {
        if (Array.isArray(remark)) {
            return !remark.join('');
        }
        return !remark;
    }, [remark]);
    var radioPart = useMemo(function () {
        return (React.createElement(Radio, { style: {
                marginRight: 12,
            }, checked: checked }));
    }, [checked]);
    var checkBoxPart = useMemo(function () {
        return (React.createElement(Checkbox, { disabled: disabled, style: {
                marginRight: 12,
            }, checked: checked }));
    }, [checked, disabled]);
    var checker = useMemo(function () {
        if (single) {
            return radioPart;
        }
        return checkBoxPart;
    }, [checkBoxPart, radioPart, single]);
    var avatarNode = useMemo(function () {
        var _a, _b;
        var _c = data || {}, avatar = _c.avatar, name = _c.name, displayName = _c.displayName;
        // if (!avatar) {
        //     return <Avatar defualtImg={defualtImg} alt={name} />;
        // }
        if (React.isValidElement(avatar)) {
            return avatar;
        }
        return (React.createElement(Avatar, { tag: data.accountType === 1 || ((_b = (_a = data.origin) === null || _a === void 0 ? void 0 : _a.info) === null || _b === void 0 ? void 0 : _b.accountType) === 1 ? '公共账号' : '', 
            // @ts-ignore
            src: getHeadImgThumbUrl(avatar, 150, 150), name: displayName || name, size: DefaultAvatarSize, type: isGroup ? "group" : "user" }));
    }, [data]);
    var itemClick = function (e) {
        e.stopPropagation();
        e.preventDefault();
        if (disabled)
            return;
        if (isCheckEnable && onCheckChange) {
            onCheckChange(data);
        }
        else if (onClick) {
            onClick(data);
        }
    };
    var descContent = useMemo(function () {
        if (data.desc) {
            return data.desc;
        }
        else {
            return '';
        }
    }, [data]);
    var listItemClasses = useMemo(function () {
        var classObj = {
            focusListItem: true,
            active: active,
            disabled: disabled,
        };
        if (className) {
            classObj[className] = true;
        }
        return classNames(classObj);
    }, [active, className, disabled]);
    var closedNode = function () { return (React.createElement("div", null,
        React.createElement("div", { className: "focus-user-selection-right-close left-close", onClick: function () {
                onItemDelete(data);
            }, onKeyDown: function () { }, tabIndex: 0, role: "button" },
            React.createElement("img", { src: closeIcon, alt: "" })))); };
    return (React.createElement("div", __assign({ className: listItemClasses, style: __assign(__assign(__assign({}, style), hStyle), { position: 'relative' }), onClick: itemClick, tabIndex: 0, role: "button", onKeyDown: function () { } }, other),
        isCheckEnable && checker,
        rightExtra && !freeze && closedNode(),
        React.createElement("div", { className: "item-avatar" }, avatarNode),
        React.createElement("div", { className: "item-content" },
            React.createElement("h4", null,
                React.createElement("div", { className: "item-content-name", id: "item-content-name" }, name),
                (isShowRemark || itemShowRemark) && !reamrkIsNull && (React.createElement(React.Fragment, null,
                    "(",
                    React.createElement("div", { className: "item-content-name item-content-remark", style: { maxWidth: "calc(100% - 100px)" } }, remark),
                    ")")),
                tag && React.createElement("div", { className: "item-content-tag" }, tag),
                React.createElement("div", { className: "special-tag" }, sortTagList &&
                    sortTagList.map(function (item, index) {
                        return React.createElement(Tags, { item: item, key: index });
                    }))),
            descContent && React.createElement("p", { className: "item-content-desc" }, descContent)),
        selector && React.createElement("div", { className: "item-selector" }, selector),
        extra && React.createElement("div", { className: "item-extra" }, extra),
        rightExtra && (React.createElement("div", { className: "item-extra" }, rightExtra.render(data, onChangeItem, onChangeDataAll)))));
}
//# sourceMappingURL=index.js.map